import { render, staticRenderFns } from "./GamesAssignCompany.vue?vue&type=template&id=d92435ca&scoped=true"
import script from "./GamesAssignCompany.vue?vue&type=script&lang=js"
export * from "./GamesAssignCompany.vue?vue&type=script&lang=js"
import style0 from "./GamesAssignCompany.vue?vue&type=style&index=0&id=d92435ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92435ca",
  null
  
)

export default component.exports